import React, { Component } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Icon, Popover, Badge, Empty } from "antd";
import { History } from "history";
import { PaginationInfoType } from "../../BusinessPartnerLists/types";
import { Scrollbars } from "react-custom-scrollbars";

interface NotificationProps extends RouteComponentProps<any> {
  history: History;
  notification: any;
  pageInfo: PaginationInfoType;
  updateNotification: (payload: any) => any;
}
interface NotificationState {
  visible: boolean;
}

class Notification extends Component<NotificationProps, NotificationState> {
  constructor(props: NotificationProps) {
    super(props);
    this.state = {
      visible: false
    };
  }

  viewNotificationDetails(id: number) {
    this.props.history.push(`/business-partner-details/${id}`);
    const updateNotificationPayload = {
      bpId: id,
      isViewed: true
    };
    this.props.updateNotification(updateNotificationPayload);
    this.setState({
      visible: false
    });
  }
  handleVisibleChange = (visible: boolean) => {
    this.setState({ visible });
  };

  render() {
    const { notification, pageInfo } = this.props;
    return (
      <Popover
        trigger="click"
        placement="bottomRight"
        overlayClassName="notification-info-popover"
        className="counter-wrap"
        visible={this.state.visible}
        onVisibleChange={this.handleVisibleChange}
        title="Notification"
        content={
          <div>
            <Scrollbars autoHeight autoHeightMin={75} autoHeightMax={300}>
              <ul className="notification-list-wrap">
                {notification &&
                  notification.map(item => (
                    <li
                      key={item.bpId}
                      onClick={() => this.viewNotificationDetails(item.bpId)}
                    >
                      <h2 style={{ fontSize: 13 }}>{item.bpName}</h2>
                      <div>
                        {`${item.bpStreet}, ${item.bpPostalcodeRefName} `}
                      </div>
                      <div>
                        was{" "}
                        <span className={item.bpActionName.toLowerCase()}>
                          {`${item.bpActionName.toLowerCase()} `}
                        </span>
                        by{" "}
                        <em>
                          <b>{item.bpModifiedPerson}</b>
                        </em>
                        .
                      </div>
                    </li>
                  ))}
                {pageInfo && pageInfo.totalRecords === 0 && (
                  <Empty
                    description={
                      <span>No notifcations available at the moment.</span>
                    }
                  />
                )}
              </ul>
            </Scrollbars>
          </div>
        }
      >
        <Icon type="bell" className="notification-icon" />
        {pageInfo && pageInfo.totalRecords > 0 && (
          <Badge
            count={pageInfo.totalRecords}
            style={{ backgroundColor: "#e28a18" }}
          />
        )}
      </Popover>
    );
  }
}

export default Notification;
